import {parseDatasetToProps} from "./parseDatasetToProps";

const isOverflown = ({ clientHeight, scrollHeight }) => {
    return scrollHeight > clientHeight + 100;
}

const resizeText = (element, parent) => {
    const fontSizeStyle = window.getComputedStyle(element, null).getPropertyValue('font-size');
    const activeFontSize = parseFloat(fontSizeStyle);
    let i = activeFontSize || 22; //start with active font size and fallback to 22
    let overflow = isOverflown(parent);
    const minSize = 9; // bare minimum font can scale down to

    while (overflow && i > minSize) {
        element.style.fontSize = `${i}px`
        overflow = isOverflown(parent);
        if (overflow) i--
    }

    element.style.fontSize = `${i - 1}px`
}

const brochures = Array.from(document.querySelectorAll('.brochure'));
brochures.forEach(brochure => {
    const pages = Array.from(brochure.querySelectorAll('.brochure__page'));
    const tableOfContents = document.getElementById('table-of-contents');

    // Generate table of contents and set page numbers based on set properties
    pages.forEach((page, index) => {
        const props = parseDatasetToProps(page.dataset);
        const tableOfContentsId = props['tableOfContents'];

        // Set page number in footer
        let pageNumber = page.querySelectorAll('.page__number')[0];
        if (pageNumber) {
            pageNumber.innerHTML = index + 1;
        }

        // Build table of contents entry including styling
        if (tableOfContentsId) {
            const tableIndexEl = document.createElement('div');
            const pageNumberEl = document.createElement('div');
            const textEl = document.createElement('div');
            pageNumberEl.classList.add('d-flex', 'align-items-center', 'justify-content-center', 'bg-primary', 'rounded-circle', 'mr-4', 'text-white', 'font-weight-bold');
            pageNumberEl.style.width = '50px';
            pageNumberEl.style.height = '50px';
            pageNumberEl.innerHTML = `${index + 1}`;
            textEl.innerHTML = tableOfContentsId;
            tableIndexEl.classList.add('d-flex', 'align-items-center', 'pb-4');
            tableIndexEl.appendChild(pageNumberEl);
            tableIndexEl.appendChild(textEl);
            tableOfContents.appendChild(tableIndexEl);
        }

        // Resize font size for all texts marked with resizable class to make sure content fits dynamic pages
        const resizableTexts = page.querySelectorAll('.resizable');
        resizableTexts.forEach((text) => {
            resizeText(text, page)
        })
    });
});

